<div class="bg-light rounded border my-4 p-3">
  <span class="h4">Calculated Logic</span>
  <app-expand-collapse-button [targetSectionId]="'preApprovalExplanationExpandCollapse'"></app-expand-collapse-button>
  <app-expand-collapse-section [sectionId]="'preApprovalExplanationExpandCollapse'" [isOpen]="false">
    <pre class="pt-3 mb-0">{{claimDto!.preApprovalExplanation}}</pre>
  </app-expand-collapse-section>
</div>